import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Kiosk from './Kiosk.js';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { useTranslation } from 'react-i18next';

export default function ThankYou ({ insights, handleProgressSubmit, embedded, embeddedPanelHeight }) {
	const { t } = useTranslation('survey');

	useEffect(() => {
		handleProgressSubmit('Thank you');
	}, []);

	const currentLocation = useLocation();

	const shareData = {
		title: insights.structure[0].props.title,
		text: insights.structure[0].props.title,
		url: window.location.href,
	};

	// Share sheet button
	const shareSheet = async () => {
		try {
			insights.actions.interaction('share', window.location.href, insights.structure[0].props.title);
			await navigator.share(shareData);
		} catch (err) {
			// console.error(`Error: ${err}`);
		}
	};

	// Check the wrapper heights.
	if (embedded) {
		setTimeout(() => {
			embeddedPanelHeight('thanks');
		}, 500);
	}

	// Set button label
	let button_text = t('survey.phrases.more');
	{insights.structure.map((str) => {
		if (str.view === 'thanks') {
			if (str.props.more_button_text && str.props.more_button_text !== '') {
				button_text = str.props.more_button_text;
			}
		}
	})}

	return (
		<>
			<div>
				<Routes>
					<Route path="/kiosk" element={<Kiosk />} />
				</Routes>
			</div>
			<div className="survey survey--thanks">
				<main className="survey__panel survey__panel--full survey__thanks">
					{insights.structure.map((str) => {
						if (str.view === 'thanks') {
							return (
								<div key={str.view} className="survey__review">
									<h1>{str.props.title}</h1>
									<div className="markdown">
										<Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{str.props.statement}</Markdown>
									</div>
								</div>
							);
						}
					})}
				</main>
				{insights.structure.map((str) => {
					if (str.view === 'thanks') {
						if (currentLocation.pathname === '/kiosk') {
							return (
								<div className="survey__footer">
									<a className="button internal" href="javascript:window.location.reload();">{t('survey.phrases.restart')}</a>
								</div>
							);
						} else if (
							str.props.more_url || !str.props.more_url == '' ||
							str.props.more_statement || !str.props.more_statement == '' ||
							str.props.share
						) {
							return (
								<div className="survey__footer">
									{(str.props.more_statement && str.props.more_statement !== '') ? <div><Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{str.props.more_statement}</Markdown></div> : null}
									<div className="survey__footer-buttons">
										{(str.props.more_url && str.props.more_url !== '') ? <a className="button" target="_blank" rel="noopener noreferrer" href={str.props.more_url}>{button_text}</a> : null}
										{(str.props.share && navigator.canShare) ? <button className="button button--share" onClick={shareSheet}>{t('survey.generic.Share')}</button> : null}
									</div>
								</div>
							);
						}
					}
				})}
			</div>
		</>
	);
}
